<template>
  <v-select
    @change="(e) => $emit(`change`, e)"
    :items="items"
    :label="label"
    style="max-width: 20% !important"
    dense
    item-text="name"
    item-value="rid"
    class="mt-5"
    :value="value"
    clearable
  />
</template>

<script>
export default {
  props: {
    label: String,
    items: Array,
    value: Object,
  },
};
</script>